import { GlobalBaseData } from "@sphtech/dmg-design-system";

import { HomeLayoutProps } from "../layouts/Home/Elements/utils";

// Type guard function
const hasMagazineIssues = (payload: unknown): payload is GlobalBaseData => {
  return (
    typeof payload === "object" &&
    payload !== null &&
    "magazineIssues" in payload
  );
};

export const extractMagazineIssues = (
  data: unknown,
): HomeLayoutProps["data"]["magazineIssues"] | undefined => {
  if (hasMagazineIssues(data)) {
    const magIssues = data.magazineIssues;

    return (
      magIssues && {
        type: "list",
        title: magIssues.title || "",
        titleZH: magIssues.titleZH,
        url: magIssues.url || "",
        subscriptionInfo: {
          heading: magIssues.config?.home?.title || "",
          description: magIssues.config?.home?.subtitle || "",
          buttonText: magIssues.config?.home?.buttonText || "",
          buttonUrl: magIssues.config?.home?.buttonUrl || "",
          hideSubscriptionInfo:
            magIssues.config?.home?.hideSubscriptionInfo || "",
        },
        items:
          magIssues.teasers?.map((issue) => {
            const crop =
              issue.image?.crops.original || issue.image?.crops.portrait;
            return {
              url: issue.path || "",
              image: crop?.src || "",
              srcWidth: crop?.srcWidth || 0,
              srcHeight: crop?.srcHeight || 0,
              alt: issue.image?.alt || "",
              caption: issue.title || "",
              description: issue.description || "",
            };
          }) || [],
      }
    );
  }
};
